import { NoteState } from './types'

export const state: NoteState = {
  plcId: '',
  notesForPlc: [],
}
